import styled from 'styled-components';

const NameRow = styled.div`
  display: flex;
  gap: ${props => props.theme.horizontalFieldGap || '5px'};

  > * {
    flex: 1;

    &:last-child {
      flex: ${props => props.theme.nameRow?.lastNameFlex || '3'};
    }
  }
`;
export default NameRow;
